export default __webpack_public_path__ + "static/media/vn.bc191547.svg";